export default __webpack_public_path__ + "static/media/image.gudppl.405f06f1.png";